import React, { useMemo, useState } from 'react'
import '../RecordDetailsPage.scss'
import { GraniteDataGrid, Checkbox } from '@tecuity/granite-ui'
import format from 'date-fns/format'
// import { useDispatch } from 'react-redux'

const NotaryTabPanel = ({ fieldSettings = {}, data = [], title = '' }) => {
  const [pageSize, setPageSize] = useState(10)
  // const dispatch = useDispatch()

  const defaultTemplate = [
    {
      field: 'ServiceType',
      headerName: 'Special Service Type',
      flex: 0.5,
      disableColumnMenu: true,
      renderCell: (params) => {
        return params.row.NotarySoftwareType.Name
      },
    },
    {
      field: 'Name',
      headerName: 'Service Provider',
      flex: 0.5,
      disableColumnMenu: true,
      renderCell: (params) => {
        return params.row.NotarySoftwareProvider.Name
      },
    },
    {
      field: 'Description',
      headerName: 'Technology Description',
      flex: 1,
      disableColumnMenu: true,
    },
  ]

  const template = useMemo(() => {
    if (fieldSettings && Object.entries(fieldSettings).length > 0) {
      const temp = []
      Object.entries(fieldSettings).map(([key, val]) => {
        if (val.Enabled) {
          temp.push({
            field: key,
            flex: 0.5,
            headerName: val.DisplayName,
            disableColumnMenu: true,
            renderCell: (params) => params.value,
          })
        }
        return null
      })
      return temp
    } else return defaultTemplate
  }, [data, fieldSettings])

  const ReadAddress = (address = {}) => {
    const showNewLine =
      (address.AddressLine1 || address.AddressLine2 || address.AddressLine3) &&
      (address.City || address.StateOrProvince || address.PostalCode)
    return (
      (address.AddressLine1 ? address.AddressLine1 : '') +
      (showNewLine ? '\n' : '') +
      (address.AddressLine2 ? address.AddressLine2 + '\n' : '') +
      (address.AddressLine3 ? address.AddressLine3 + '\n' : '') +
      (address.City ? address.City + ',' : '') +
      ' ' +
      (address.StateOrProvince ? address.StateOrProvince : '') +
      ' ' +
      (address.PostalCode ? address.PostalCode : '')
    )
  }

  const ReadValue = (fieldType, value) => {
    let curratedValue = value || value === false ? value : 'N/A'
    switch (fieldType) {
      case 0:
        break
      case 2:
        return ReadAddress(curratedValue)
      case 4:
        return value ? format(new Date(curratedValue), 'MM/dd/yyyy') : curratedValue
      case 16:
        return value ? value.Name : ''
      case 32:
        return <Checkbox checked={value} disabled={true} ariaLabel={`Checkbox`} />
      case 64:
        return value ? 'Good' : 'Bad'
      case 128:
        return value
      default:
        console.error('Uncertain Field Type: ' + fieldType + ' for value: ' + value)
        break
    }
    return value
  }

  const tableRows = useMemo(() => {
    const rows = data.map((party, i) => {
      if (fieldSettings && Object.entries(fieldSettings).length > 0) {
        const row = {
          id: i,
        }
        Object.keys(fieldSettings).forEach((key) => {
          Object.assign(row, { [key]: ReadValue(fieldSettings[key].FieldType || 0, party[key]) })
        })
        return row
      } else return { ...party, id: i }
    })
    return rows
  }, [data, fieldSettings])

  return (
    <div
      className="row"
      style={{ marginBottom: '80px', display: 'flex', flexDirection: 'row', gap: '20px' }}
    >
      <h2>{title}</h2>
      <GraniteDataGrid
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[10, 25, 50]}
        getRowId={(row) => row.id}
        columns={template}
        rows={tableRows}
      />
    </div>
  )
}

export default NotaryTabPanel
